var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-cases-en row-container"},[_c('ul',{staticClass:"items"},_vm._l((_vm.items),function(item){return _c('el-card',{key:item.index,attrs:{"shadow":"hover"}},[_c('li',[_c('img',{attrs:{"src":item.logo,"alt":""}})])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }